import React from 'react';
import PropTypes from 'prop-types';

class DatabaseField extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.arrayOf(
      PropTypes.shape({
        group: PropTypes.string,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            value: PropTypes.number,
            label: PropTypes.string
          })
        )
      })
    ),
    classSlug: PropTypes.string.isRequired,
    databaseId: PropTypes.number,
    onDatabaseChange: PropTypes.func.isRequired
  };

  handleChange = (e) => {
    const value = parseInt(e.target.value);
    this.props.onDatabaseChange(value);
  };

  isSelected = id => id == this.props.databaseId;

  setOptionGroups = () => {
    const { availableDatabases } = this.props;

    return availableDatabases.map(database => (
      <optgroup key={database.group} label={database.group}>
        {this.setOptions(database.options)}
      </optgroup>
    ));
  };

  setOptions = (options) => {
    return _.map(options, option => (
      <option key={option.value} selected={this.isSelected(option.value)} value={option.value}>
        {option.label}
      </option>
    ));
  };

  render() {
    const { classSlug, databaseId } = this.props;

    return (
      <div className={`form-group grouped_select required ${classSlug}_database_id`}>
        <label className="form-label grouped_select required">
          Database
        </label>
        <div className="form-input-container">
          <select
            className="form-select grouped_select required"
            required={true}
            onChange={this.handleChange}
          >
            <React.Fragment>
              <option value="">Select a database...</option>
              {this.setOptionGroups()}
            </React.Fragment>
          </select>
          <input
            id={`${classSlug}_database_id`}
            name={`${classSlug}[database_id]`}
            type="hidden"
            value={databaseId}
          />
        </div>
      </div>
    );
  }
}

export default DatabaseField;
